import {observer} from "mobx-react";
import ReactDOM from "react-dom";
import {useEffect, useRef, useState} from "react";
import {useServices} from "../../react-hooks/use-services.hook";
import {Magic8BallAnimation} from "./magic-8-ball-animation";
import {CloseIcon} from "../../themes/defaults/icons/close.icon";
import {Magic8BallOverlayBox} from "./boxes/magic-8-ball-overlay.box";
import {Magic8BallOverlayCloseBox} from "./boxes/magic-8-ball-overlay-close.box";
import {Magic8BallDisclaimerBox} from "./boxes/magic-8-ball-disclaimer.box";
import {Magic8BallMobileLandscapeWarningBox} from "./boxes/magic-8-ball-mobile-landscape-warning.box";
import {clamp} from "../../../common/utils/math-util";
import {Link} from "../raw-components/link/link";

interface IMagic8BallComponentProps {
    showIntent: boolean;
    prizes: string[];
    prizeWonIndex: number;
    onShakeStart?(): void;
    onShakeEnd?(): void;
    onClose?(): void;
    onPrizeClaim?(): void;
}

export const Magic8BallAnimationComponent: React.FC<IMagic8BallComponentProps> = observer((props) => {
    const services = useServices();
    let magic8BallContainerElementRef = useRef<HTMLDivElement>(null);
    let magic8BallAnimation = useRef<null | Magic8BallAnimation>(null);
    let [isShown, setIsShown] = useState(false);
    let [sizeScale, setSizeScale] = useState(1);

    useEffect(() => {
        if (props.showIntent) {
            if (services.mediaQuery.mAndBelow && services.mediaQuery.landscape) {
                // we must show the layer so the user can see the rotate device message
                setIsShown(true);
            } else if (magic8BallContainerElementRef.current) {
                services.gsap.then(gsapService => {
                    let magic8BallAnim = new Magic8BallAnimation(
                        services,
                        gsapService,
                        props.prizes,
                        props.prizeWonIndex,
                        props.onShakeStart,
                        props.onShakeEnd,
                        props.onPrizeClaim,
                        (newScale) => {
                            setSizeScale(newScale);
                        }
                    );
                    const initPromise = magic8BallAnim.init();
                    initPromise.then(() => {
                        setIsShown(true);
                    });
                    magic8BallAnim.attachToDOM(magic8BallContainerElementRef.current)
                    magic8BallAnimation.current = magic8BallAnim;
                });
            }
        }
        if (!props.showIntent) {
            setIsShown(false);
        }
        return () => {
            if (magic8BallAnimation.current) {
                magic8BallAnimation.current.dispose();
                magic8BallAnimation.current = null
            }
        }
    }, [
        props.showIntent, props.prizes, props.prizeWonIndex,
        props.onShakeStart, props.onShakeEnd, props.onPrizeClaim,
        services, services.mediaQuery.mAndBelow, services.mediaQuery.landscape
    ]);

    return ReactDOM.createPortal(<Magic8BallOverlayBox isShown={isShown}>
        <div style={{position: "relative"}}>
            <Magic8BallOverlayCloseBox
                onClick={() => {
                    setIsShown(false);
                    if (props.onClose) { props.onClose(); }
                }}
            >
                <CloseIcon size={3} />
            </Magic8BallOverlayCloseBox>
            <div ref={magic8BallContainerElementRef}>
                {props.showIntent && services.mediaQuery.mAndBelow && services.mediaQuery.landscape ? <Magic8BallMobileLandscapeWarningBox>
                    <div>
                        <img
                            src={services.theme.currentTheme.assets.images.rotate_phone_landscape_png.toString()}
                            style={{display: "block", margin: "0 auto 1rem"}}
                            alt="rotate phone from landscape to portrait"
                        />
                    </div>
                    <div>{services.translation.translate("ROTATE_DEVICE_TO_PORTRAIT")}</div>
                </Magic8BallMobileLandscapeWarningBox> : null}
            </div>
            <Magic8BallDisclaimerBox style={{fontSize: clamp(1.4 * sizeScale, 1, 1.4) + "rem"}}>
                New 777casino register get 1 free spin. Deposit min €10 for one daily spin. Existing players with min €10 lifetime deposit can spin one a day.
                Prizes must be claimed within 24 hours and vary between Cash, Free Spins and Bonus. Odds differ between prizes. no guaranteed win.
                Bonus valid for selected games, must be wagered X5 and expires after 60 days. Free Spins set at €0.10 per spin, valid for selected slots games and must be used within 7 days.
                <Link href="?">Full T&C apply</Link>
            </Magic8BallDisclaimerBox>
        </div>
    </Magic8BallOverlayBox>, document.body);
});